import {
    INICIA_ATIVIDADE_PEDAGOGICA,
    INICIO_ATIVIDADE_PEDAGOGICA_SUCESSO,
    LISTA_ATIVIDADE_PEDAGOGICA,
    LISTA_ATIVIDADE_PEDAGOGICA_SUCESSO,
    SALVA_ATIVIDADE_PEDAGOGICA,
    SALVA_ATIVIDADE_PEDAGOGICA_SUCESSO,
    REMOVE_ATIVIDADE_PEDAGOGICA,
    REMOVE_ATIVIDADE_PEDAGOGICA_SUCESSO,
    BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO,
    BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO_SUCESSO,
    NOVA_ATIVIDADE_PEDAGOGICA,
    ATUALIZA_ATIVIDADE_PEDAGOGICA,
    LIMPAR_ATIVIDADE_PEDAGOGICA,
    LISTA_TURMAS_PARA_ATIVIDADE,
    LISTA_TURMAS_PARA_ATIVIDADE_SUCESSO,
    LISTA_ESCOLAS_ATIVIDADE,
    LISTA_ESCOLAS_ATIVIDADE_SUCESSO,
    LISTA_CURSOS_ATIVIDADE,
    LISTA_CURSOS_ATIVIDADE_SUCESSO,
    LISTA_SERIES_ATIVIDADE,
    LISTA_SERIES_ATIVIDADE_SUCESSO,
    LISTA_ETAPAS_ATIVIDADE,
    LISTA_ETAPAS_ATIVIDADE_SUCESSO,
    LISTA_DISCIPLINAS_ATIVIDADE,
    LISTA_DISCIPLINAS_ATIVIDADE_SUCESSO,
    LISTA_ALUNOS_TURMA_ATIVIDADE,
    LISTA_ALUNOS_TURMA_ATIVIDADE_SUCESSO,
    LIMPAR_FILTROS_ATIVIDADE,
    NOVA_ATIVIDADE_PEDAGOGICA_LOTE,
    SALVA_ATIVIDADE_PEDAGOGICA_LOTE,
    SALVA_ATIVIDADE_PEDAGOGICA_LOTE_SUCESSO,
    ON_SHOW_LOADER,
    SHOW_MESSAGE,
    SHOW_MESSAGE_SUCCESS,
    SHOW_MESSAGE_ERROR,
    HIDE_MESSAGE
} from 'constants/ActionTypes';

export const iniciaAtividadePedagogica = () => {
    return {
        type: INICIA_ATIVIDADE_PEDAGOGICA
    };
};

export const inicioAtividadePedagogicaSucesso = () => {
    return {
        type: INICIO_ATIVIDADE_PEDAGOGICA_SUCESSO
    };
};

export const listaAtividadePedagogica = (filtro) => {
    return {
        type: LISTA_ATIVIDADE_PEDAGOGICA,
        payload: filtro
    };
};

export const listaAtividadePedagogicaSucesso = (lista) => {
    return {
        type: LISTA_ATIVIDADE_PEDAGOGICA_SUCESSO,
        payload: lista
    };
};

export const salvaAtividadePedagogica = (dados) => {
    return {
        type: SALVA_ATIVIDADE_PEDAGOGICA,
        payload: dados
    };
};

export const salvaAtividadePedagogicaSucesso = (dados) => {
    return {
        type: SALVA_ATIVIDADE_PEDAGOGICA_SUCESSO,
        payload: dados
    };
};

export const removeAtividadePedagogica = (id) => {
    return {
        type: REMOVE_ATIVIDADE_PEDAGOGICA,
        payload: id
    };
};

export const removeAtividadePedagogicaSucesso = (id) => {
    return {
        type: REMOVE_ATIVIDADE_PEDAGOGICA_SUCESSO,
        payload: id
    };
};

export const buscaAtividadePedagogicaEdicao = (id) => {
    return {
        type: BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO,
        payload: id
    };
};

export const buscaAtividadePedagogicaEdicaoSucesso = (dados) => {
    return {
        type: BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO_SUCESSO,
        payload: dados
    };
};

export const novoAtividadePedagogica = () => {
    return {
        type: NOVA_ATIVIDADE_PEDAGOGICA
    };
};

export const atualizaAtividadePedagogica = (campo, valor) => {
    return {
        type: ATUALIZA_ATIVIDADE_PEDAGOGICA,
        payload: { campo, valor }
    };
};

export const limparAtividadePedagogica = () => {
    return {
        type: LIMPAR_ATIVIDADE_PEDAGOGICA
    };
};

export const cancelaEdicao = () => {
    return {
        type: LIMPAR_ATIVIDADE_PEDAGOGICA
    };
};

export const listaTurmasParaAtividade = (filtros) => {
    return {
        type: LISTA_TURMAS_PARA_ATIVIDADE,
        payload: filtros
    };
};

export const listaTurmasParaAtividadeSucesso = (lista) => {
    return {
        type: LISTA_TURMAS_PARA_ATIVIDADE_SUCESSO,
        payload: lista
    };
};

// Actions Filtros Cascata
export const listaEscolasAtividade = () => ({
    type: LISTA_ESCOLAS_ATIVIDADE
});

export const listaEscolasAtividadeSucesso = (escolas) => ({
    type: LISTA_ESCOLAS_ATIVIDADE_SUCESSO,
    payload: escolas
});

export const listaCursosAtividade = (escolaId, anoLetivo, manterSelecao = false) => ({
    type: LISTA_CURSOS_ATIVIDADE,
    payload: { escolaId, anoLetivo, manterSelecao }
});

export const listaCursosAtividadeSucesso = (cursos) => ({
    type: LISTA_CURSOS_ATIVIDADE_SUCESSO,
    payload: cursos
});

export const listaSeriesAtividade = (cursoId, manterSelecao = false) => ({
    type: LISTA_SERIES_ATIVIDADE,
    payload: { cursoId, manterSelecao }
});

export const listaSeriesAtividadeSucesso = (series) => ({
    type: LISTA_SERIES_ATIVIDADE_SUCESSO,
    payload: series
});

export const listaEtapasAtividade = (escolaId, anoLetivo, manterSelecao = false) => ({
    type: LISTA_ETAPAS_ATIVIDADE,
    payload: { escolaId, anoLetivo, manterSelecao }
});

export const listaEtapasAtividadeSucesso = (etapas) => ({
    type: LISTA_ETAPAS_ATIVIDADE_SUCESSO,
    payload: etapas
});

export const listaDisciplinasAtividade = (escolaId, serieId, anoLetivo, turmaId, manterSelecao = false) => ({
    type: LISTA_DISCIPLINAS_ATIVIDADE,
    payload: { escolaId, serieId, anoLetivo, turmaId, manterSelecao }
});

export const listaDisciplinasAtividadeSucesso = (disciplinas) => ({
    type: LISTA_DISCIPLINAS_ATIVIDADE_SUCESSO,
    payload: disciplinas
});

export const listaAlunosTurmaAtividade = (turmaId, manterSelecao = false) => ({
    type: LISTA_ALUNOS_TURMA_ATIVIDADE,
    payload: { turmaId, manterSelecao }
});

export const listaAlunosTurmaAtividadeSucesso = (alunos) => ({
    type: LISTA_ALUNOS_TURMA_ATIVIDADE_SUCESSO,
    payload: alunos
});

export const limparFiltrosAtividade = () => ({
    type: LIMPAR_FILTROS_ATIVIDADE
});

export const novoAtividadePedagogicaLote = () => ({
    type: NOVA_ATIVIDADE_PEDAGOGICA_LOTE
});

export const salvaAtividadePedagogicaLote = (dados) => ({
    type: SALVA_ATIVIDADE_PEDAGOGICA_LOTE,
    payload: dados
});

export const salvaAtividadePedagogicaLoteSucesso = (dados) => ({
    type: SALVA_ATIVIDADE_PEDAGOGICA_LOTE_SUCESSO,
    payload: dados
});

export const showLoader = () => {
    return {
        type: ON_SHOW_LOADER,
    };
};

export const showMessage = (message) => {
    return {
        type: SHOW_MESSAGE,
        payload: message,
    };
};

export const showMessageSuccess = (message) => {
    return {
        type: SHOW_MESSAGE_SUCCESS,
        payload: message,
    };
};

export const showMessageError = (message) => {
    return {
        type: SHOW_MESSAGE_ERROR,
        payload: message,
    };
};

export const hideMessage = () => {
    return {
        type: HIDE_MESSAGE,
    };
};
